import { Badge } from "@/components/ui/badge";

export default function CardPaymentsPage() {
  return (
    <div className="flex-1 space-y-6 p-4 md:p-6 pt-6">
      {/* Header */}
      <div className="flex flex-col items-center justify-center text-center space-y-4 py-8">
        <Badge variant="secondary" className="bg-purple-100 text-purple-700 dark:bg-purple-900 dark:text-purple-300">
          Coming Soon
        </Badge>
        <div className="space-y-2">
          <h2 className="text-3xl font-bold tracking-tight">Card Payments Coming Soon</h2>
          <p className="text-muted-foreground max-w-2xl">
            We're building a comprehensive card payment solution to help you manage credit and debit card transactions efficiently. 
            This feature is currently under development and will be available soon.
          </p>
        </div>
      </div>
    </div>
  );
}
